let context = null;
function audioContext() {
  if (!context || context.state === "closed") {
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return null;
    context = new Audio();
  }
  return context;
}
export const isSoundReady = () => context?.state === "running";
const ringingNodes = new Set();
export function stopCallRingtone() {
  for (const node of ringingNodes) {
    try { node.oscillator.stop(); node.oscillator.disconnect(); node.gain.disconnect(); } catch {}
  }
  ringingNodes.clear();
}

function ringPhone(ctx) {
  stopCallRingtone();
  // Three double rings with a pause between pairs, like an incoming phone call.
  for (const offset of [0, 1, 3.5, 4.5, 7, 8]) {
    for (const frequency of [440, 480]) {
      const oscillator = ctx.createOscillator(), gain = ctx.createGain();
      const node = {oscillator,gain}, start = ctx.currentTime + offset;
      oscillator.type = 'sine'; oscillator.frequency.value = frequency;
      oscillator.connect(gain); gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.001,start);
      gain.gain.exponentialRampToValueAtTime(0.12,start+0.02);
      gain.gain.setValueAtTime(0.12,start+0.7);
      gain.gain.exponentialRampToValueAtTime(0.001,start+0.78);
      ringingNodes.add(node);
      oscillator.onended=()=>{ringingNodes.delete(node);oscillator.disconnect();gain.disconnect();};
      oscillator.start(start);oscillator.stop(start+0.8);
    }
  }
}

// Call from a staff tap/key press so mobile browsers permit later alert sounds.
export async function unlockSound() {
  try {
    const ctx = audioContext();
    if (!ctx) return false;
    if (ctx.state !== "running") await ctx.resume();
    return ctx.state === "running";
  } catch { return false; }
}

export function beep(kind = "notification") {
  try {
    const ctx = audioContext();
    if (!ctx || ctx.state !== "running") return false;
    if (kind === 'call') { ringPhone(ctx); return true; }
    if (kind === 'order') {
      // A bright bell strike with a three-second ringing tail.
      for (const [frequency, volume] of [[880,0.22],[1760,0.07],[2640,0.025]]) {
        const oscillator=ctx.createOscillator(),gain=ctx.createGain(),start=ctx.currentTime;
        oscillator.type='sine';oscillator.frequency.value=frequency;
        oscillator.connect(gain);gain.connect(ctx.destination);
        gain.gain.setValueAtTime(0.001,start);
        gain.gain.exponentialRampToValueAtTime(volume,start+0.015);
        gain.gain.exponentialRampToValueAtTime(0.001,start+3);
        oscillator.onended=()=>{oscillator.disconnect();gain.disconnect();};
        oscillator.start(start);oscillator.stop(start+3);
      }
      return true;
    }
    const tones = [0, 0.18];
    tones.forEach((offset, index) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      const start = ctx.currentTime + offset;
      oscillator.frequency.value = 880;
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.25, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.16);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
      oscillator.start(start);
      oscillator.stop(start + 0.18);
    });
    return true;
  } catch { return false; }
}
